module.exports = __webpack_public_path__ + "img/phyto-bg@2x.5d5de08f.jpg";